import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class AboutPage extends Component {
    render() {
        return (
            <div className="main">
                <ReactCSSTransitionGroup
                    transitionAppear={true}
                    transitionAppearTimeout={600}
                    transitionEnterTimeout={600}
                    transitionLeaveTimeout={200}
                    transitionName={'SlideIn'}
                >
                <div className="page">
                    <p>Efterlysning &ndash; Sjukmat blir Friskmat och vi beh&ouml;ver tips p&aring; alla eldsj&auml;lar d&auml;r ute.</p>

                    <p>I januari lanserade vi p&aring; Food Pharmacy uppropet #sjukmat. Ett upprop som vi hoppas ska leda till att Sveriges
                        beslutsfattare b&ouml;rjar ta sitt ansvar f&ouml;r att maten som serveras p&aring; Sveriges sjukhus, f&ouml;rskolor,
                        skolor och &auml;ldreboenden ger oss n&auml;ring och bidrar till att g&ouml;ra oss friska, i st&auml;llet f&ouml;r tv&auml;rtom.</p>

                    <p>Livsstilsrelaterade sjukdomar har &ouml;kat kraftigt de senaste &aring;ren och prognoserna tyder tyv&auml;rr p&aring;
                        att de bara kommer att forts&auml;tta &ouml;ka. Samtidigt kommer det mer och mer forskning som visar att maten vi &auml;ter
                        kan f&ouml;rebygga n&aring;gra av v&aring;ra st&ouml;rsta folksjukdomar &ndash; sjukdomar som i dag inte bara leder
                        till enormt mycket lidande utan ocks&aring; stora kostnader, b&aring;de f&ouml;r den enskilde individen och f&ouml;r
                        samh&auml;llet.</p>

                    <p>Varje dag serveras det cirka 3 miljoner m&aring;ltider i v&aring;rd, skola och omsorg och kostnaden f&ouml;r r&aring;varorna
                        till dessa m&aring;ltider uppg&aring;r till &ouml;ver 8 miljarder kronor om &aring;ret. &Aring;tta miljarder kronor
                        som i m&aring;nga fall g&aring;r till n&auml;ringsfattig mat som snarare bidrar till att g&ouml;ra oss sjuka &auml;n
                        friska.</p>

                    <p>Gensvaret p&aring; #sjukmat har varit stort och varje ber&auml;ttelse som delats har st&auml;rkt oss i v&aring;r &ouml;vertygelse
                        om att vi det beh&ouml;vs en f&ouml;r&auml;ndring. V&aring;r f&ouml;rsta milstolpe var att f&aring; 10 000 f&ouml;ljare
                        att &ouml;ppet st&ouml;dja uppropet p&aring; v&aring;r Facebook-sida och samma dag som vi n&aring;dde det m&aring;let
                        kontaktade vi Sveriges socialminister Annika Strandh&auml;ll f&ouml;r att uppm&auml;rksamma henne p&aring; uppropet.
                        I samband med det lyckades vi f&aring; till en intervju med Annika, lyssna g&auml;rna p&aring; foodpharmacy.se/podd
                        (avsnitt 33 &ndash; N&auml;r #sjukmat blir #friskmat).</p>

                    <p>Nu &auml;r det dags att byta fokus och vi kommer fr&aring;n och med nu att jobba med l&ouml;sningen ist&auml;llet f&ouml;r
                        problemet &ndash; #sjukmat blir #friskmat. V&aring;r definition av frisk mat &auml;r mat som &auml;r n&auml;ringsrik,
                        smakar gott och ser aptitlig ut. Vi kommer fokusera p&aring; de offentliga k&ouml;k som redan idag serverar frisk mat
                        och samla inspiration fr&aring;n dem och se till att den sprids till alla andra stork&ouml;k d&auml;r ute. Men vi beh&ouml;ver
                        er hj&auml;lp.</p>

                    <p>Har du en ber&auml;ttelse om &ndash; eller &auml;r du sj&auml;lv &ndash; en fantastisk f&ouml;rskolekock, ett inspirerande
                        hemtj&auml;nstk&ouml;k, ett f&ouml;red&ouml;mligt sjukhusk&ouml;k eller en eldsj&auml;l som serverar v&aring;ra &auml;ldre
                        n&auml;ringsrik och god mat? Skicka tips om dessa till friskmat@foodpharmacy.se. Vi &auml;r &ouml;vertygade om att m&aring;nga
                        sm&aring; bidrag fr&aring;n er runt om i landet kan g&ouml;ra stor skillnad. S&aring; sprid, dela, tipsa - s&aring;
                        att v&aring;r samlingsplats f&ouml;r stork&ouml;ksinspiration kan bli verklighet!</p>
                </div>
                </ReactCSSTransitionGroup>
		    </div>
        );
    }
}

export default AboutPage;


// WEBPACK FOOTER //
// ./src/components/about/AboutPage.js